import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { RequestService } from '../request';
import { ICreateProfileRequest, IProfile, IUpdateProfileRequest } from './defs';

@Injectable({
  providedIn: 'root'
})
export class ProfilesService {

  constructor(
    private request: RequestService
  ) { }

  public getList(): Observable<IProfile[]> {
    return this.request.get('/api/profiles');
  }

  public createProfile(request: ICreateProfileRequest): Observable<IProfile> {
    return this.request.post('/api/profiles', request);
  }

  public updateProfile(request: IUpdateProfileRequest): Observable<IProfile> {
    return this.request.put(`/api/profiles/${request.id}`, request);
  }

  public deleteProfile(ids: number[]): Observable<IProfile[]> {
    return forkJoin(ids.map(id => this.request.delete(`/api/profiles/${id}`)));
  }
}
